import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Popover } from 'antd';
import { formatShortDate } from '../../../../../utils/formatDatesAndHours';
import { IblogPostListingCardData } from '../../../../../types/blog';
import EditIcon from '../../../../../assets/images/catalogue/EditIcon';
import { DeleteTrashCanIcon } from '../../../../../assets/images/blogModule';
import { deleteBlogEntry } from '../../../../../services/blog';
import { displayErrorNotification, displaySuccessNotification } from 'utils/displayNudosStandardNotifications';
import { getNudosData } from '../../../../../utils/getNudosData';
import { AxiosError } from 'axios';
import './BlogPostListingCard.scss';

const BlogPostListingCard = ({
  blogEntry,
  setUploadingCounter,
  uploadingCounter
}: {
  blogEntry?: IblogPostListingCardData;
  setUploadingCounter: React.Dispatch<React.SetStateAction<number>>;
  uploadingCounter: number;
}) => {
  const { push } = useHistory();
  const [openPopover, setOpenPopover] = useState(false);
  const nudosData = getNudosData();

  const handleClickEdit = () => {
    push(`/blog/new-entry/${blogEntry?.postId}`);
  };

  const handleDeleteBlogEntry = async () => {
    const userId = nudosData && nudosData?.userData?.id;
    if (!blogEntry || !userId) return;
    try {
      const response = await deleteBlogEntry(blogEntry?.postId, userId);
      if (response) {
        displaySuccessNotification({ customJSXMessage: <>Se elimino la publicación</> });
        setUploadingCounter(uploadingCounter + 1);
      }
    } catch (error: AxiosError | any) {
      if (
        error.response.data.message === 'User cannot delete this post' ||
        error.response.message === 'User cannot delete this post' ||
        error.data.message === 'User cannot delete this post' ||
        error.message === 'User cannot delete this post'
      )
        displayErrorNotification({ customJSXMessage: <>No puedes borrar una entrada escrita por otro usuario</> });
      else displayErrorNotification();
    }
  };

  if (!blogEntry) return null;
  return (
    <div className="blogPostListingCard">
      <div className="thumb">
        <img src={blogEntry?.thumbImage} alt="Imagen entrada" />
      </div>
      <div className="title">{blogEntry.postTitle}</div>
      <div className="category">{blogEntry.category}</div>
      <div className="date">{formatShortDate(blogEntry.updatedAt)?.textWithTimezone}</div>
      <div className="author">
        <div
          className="authorImage"
          style={{
            backgroundImage: `url(${blogEntry?.authorImage ? blogEntry?.authorImage.replaceAll(' ', '%20') : ''})`
          }}
        />
        <div className="authorName">{blogEntry.authorName}</div>
      </div>
      <div className="editIconContainer" onClick={handleClickEdit}>
        <EditIcon />
      </div>
      <div className="deleteIconContainer">
        <Popover
          className="deletePostPopover rounded-md"
          trigger="click"
          arrowPointAtCenter={true}
          placement="bottomRight"
          open={openPopover}
          content={
            <div className="blogListingDeletePopoverContent">
              <div className="textPopup">¿Estás seguro de eliminar esta entrada?</div>
              <Button
                className="buttonPoup margin"
                onClick={() => {
                  setOpenPopover(false);
                }}
              >
                Cancelar
              </Button>
              <Button
                className="buttonPoup delete"
                onClick={() => {
                  handleDeleteBlogEntry();
                  setOpenPopover(false);
                }}
              >
                Eliminar
              </Button>
            </div>
          }
        />
        <DeleteTrashCanIcon onClick={() => setOpenPopover(true)} />
      </div>
    </div>
  );
};

export default BlogPostListingCard;
